import qs from 'qs';

export function getTraceId() {
  return (qs.parse(location.search, { ignoreQueryPrefix: true }).trace_id ?? '') as string;
}
